import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { HttpClientBase } from '@shared/http-client-base';
import { IAuthToken } from '@shared/interfaces';
import {
  IGetUnifiedCustomerIdForCOURequest,
  IGetUnifiedCustomerIdForCOUResponse
} from '../../interfaces/customer-entitlement.interface';

export enum CustomerEntitlementSourceURLs {
  Authorize = '/v1/authorize',
  GetClosestUnifiedCustomerIdForCOU = '/v1/get_closest_unified_customer_id_for_cou',
}

@Injectable({
  providedIn: 'root',
})
export class CustomerEntitlementSource extends HttpClientBase {
  authorize$(): Observable<IAuthToken> {
    // Service disabled
    return of({ token: '' });
  }

  getClosestUnifiedCustomerIdForCOU$(params: IGetUnifiedCustomerIdForCOURequest): Observable<IGetUnifiedCustomerIdForCOUResponse> {
    // Service disabled
    const defaultResponse: IGetUnifiedCustomerIdForCOUResponse = {
      closestUnifiedCustomerId: '',
    };
    return of(defaultResponse);  }
}
